const HeroAnimateControls = (($) => {
    class HeroAnimate {
        constructor(node) {
            this.node = node;
            this.$node = $(this.node);
            this.$overlay = this.$node.find('[data-container="overlay"]');
            this.$content = this.$node.find('[data-container="content"]');
            this.$video = this.$node.find('[data-container="video"]');
        }

        init() {
            $(window).on('scroll', () => this.setOverlayOpacity());
            $(window).on('resize', () => this.setOverlayOpacity());

            this.setOverlayOpacity(); // Set initial opacity based on scroll position at load
        }

        setOverlayOpacity() {
            const windowHeight = $(window).height();
            const nodeRect = this.$node[0].getBoundingClientRect();
            const contentRect = this.$content[0].getBoundingClientRect();
            const contentBottom = contentRect.bottom;

            if (contentRect.width === contentRect.height && nodeRect.height === contentRect.height) {
                if (this.$overlay.length) {
                    this.$overlay.css('opacity', .7);
                }
            } else {
                // Calculate the opacity:
                // Start changing when the content bottom begins to leave the viewport
                // Fully transparent when the content top is no longer visible
                let opacity = (contentBottom / windowHeight);
                opacity = Math.max(0, Math.min(opacity, 1)); // Clamping the value between 0 and 1

                if (this.$overlay.length) {
                    this.$overlay.css('opacity', opacity);
                }
                if (this.$video.length) {
                    this.$video.css('top', `${window.scrollY}px`);
                }
            }
        }

    }

    return {
        init({ selector } = {}) {
            $(selector).each((index, parent) => {
                const module = new HeroAnimate(parent);
                module.init();
            });
        },
    };
})(window.jQuery);

// DOM Ready
(($) => {
    $(document).ready(() => {
        HeroAnimateControls.init({
            selector: "[data-hero-animate]",
        });
    });
})(window.jQuery);
